import { createSelector } from '@ngrx/store';
import { featureSelect } from '../settings';
const ɵ0 = (state) => state.list;
export const getRecords = createSelector(featureSelect, ɵ0);
const ɵ1 = (state, recordId) => state.list.find(record => record.id.toString() === recordId.toString());
export const getRecordById = createSelector(featureSelect, ɵ1);
const ɵ2 = (state) => state;
export const getCurrentRecord = createSelector(featureSelect, ɵ2);
export { ɵ0, ɵ1, ɵ2 };
